import React from 'react';
import { marqueeTags } from '../mock';
import { Sparkle } from 'lucide-react';

const Marquee = () => {
  const items = [...marqueeTags, ...marqueeTags];
  return (
    <section className="py-12 md:py-16 overflow-hidden border-y border-[#143324]/10">
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((tag, i) => (
          <div key={i} className="flex items-center gap-8 px-6">
            <span className="font-serif-display text-[#143324] text-3xl md:text-5xl italic">
              {tag}
            </span>
            <Sparkle size={22} className="text-[#143324]" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
